import { useCallback } from 'react';
import { ThumbnailsPane, ThumbImg } from '@embedpdf/plugin-thumbnail/react';
import { useScroll } from '@embedpdf/plugin-scroll/react';
import type { ThumbMeta } from '@embedpdf/plugin-thumbnail';
import styles from './PdfThumbnailSidebar.module.css';

interface PdfThumbnailSidebarProps {
  documentId: string;
}

export default function PdfThumbnailSidebar({
  documentId,
}: PdfThumbnailSidebarProps) {
  const { provides: scroll, state } = useScroll(documentId);

  const handleThumbClick = useCallback(
    (pageIndex: number) => {
      scroll?.scrollToPage({ pageNumber: pageIndex + 1, behavior: 'smooth' });
    },
    [scroll]
  );

  return (
    <div className={styles.sidebar}>
      <ThumbnailsPane documentId={documentId} className={styles.pane}>
        {(meta: ThumbMeta) => {
          const isActive = state.currentPage === meta.pageIndex + 1;
          return (
            <button
              type="button"
              className={`${styles.thumbButton} ${isActive ? styles.active : ''}`}
              onClick={() => handleThumbClick(meta.pageIndex)}
            >
              <ThumbImg
                documentId={documentId}
                meta={meta}
                className={styles.thumbImg}
              />
              <span className={styles.pageLabel}>{meta.pageIndex + 1}</span>
            </button>
          );
        }}
      </ThumbnailsPane>
    </div>
  );
}
